<div class="fleet-header">
  <div class="header-top">
    <div class="logo-section">
      <img src="assets/shiv-sewa-logo.svg" alt="Company Logo" class="company-logo">
    </div>
    <button class="logout-btn" (click)="logout()">
      <i class="fa-solid fa-right-from-bracket"></i>
      <span>Logout</span>
    </button>
  </div>
</div>



    <div class="header-content">
    <div class="header-icon">
      <i class="fa-solid fa-route" style="color: darkorange;"></i>
    </div>
    <div class="header-text">
      <h5>Manage and track your assigned bookings in real-time</h5>
      <div class="status-indicators">
        <span class="indicator active"><i class="fa-solid fa-circle"></i> Active</span>
        <span class="indicator">{{ stats.pending + stats.accepted + stats.ontrip || 0 }} Trips</span>
      </div>
    </div>
  </div>


<!-- TOP STATS -->
<div class="stats-row">
  <div class="stat-card pending">
    <h3>{{ stats.pending }}</h3>
    <p>Pending</p>
  </div>
  <div class="stat-card accepted">
    <h3>{{ stats.accepted }}</h3>
    <p>Accepted</p>
  </div>
  <div class="stat-card ontrip">
    <h3>{{ stats.ontrip }}</h3>
    <p>On Trip</p>
  </div>
  <div class="stat-card completed">
    <h3>{{ stats.completed }}</h3>
    <p>Completed</p>
  </div>
</div>
<!-- TRIPS GRID -->
<div class="trips-container">
  <div class="trip-card" *ngFor="let t of trips">
    <!-- TOP AREA -->
    <div class="card-head">
      <div>
        <h4>{{ t.vehicle.name }} – {{ t.vehicle.carNumber }}</h4>
        <span class="booking-id">#{{ t.bookingRef }}</span>
      </div>
      <span class="status-badge {{ t.status | lowercase }}">
        {{ t.status }}
      </span>
    </div>
    <!-- ROUTE -->
    <div class="route-block">
      <div class="loc-row">
        <i class="fa-solid fa-location-dot start"></i>
        <p>{{ t.pickup }}</p>
      </div>
      <div class="route-line"></div>
      <div class="loc-row">
        <i class="fa-solid fa-location-dot end"></i>
        <p>{{ t.dropoff }}</p>
      </div>
    </div>
    <!-- DATE & TIME -->
    <div class="info-pair">
      <div><i class="fa-regular fa-calendar"></i> {{ t.date }}</div>
      <div><i class="fa-regular fa-clock"></i> {{ t.time }}</div>
    </div>
    <!-- CUSTOMER -->
    <div class="customer-block">
      <i class="fa-solid fa-user"></i>
      {{ t.traveller.firstName }} {{ t.traveller.lastName }}
    </div>
    <!-- ACTION BUTTONS -->
    <div class="action-row">
      <button (click)="call(t.traveller.mobile)">
        <i class="fa-solid fa-phone"></i>
      </button>
      <button (click)="whatsapp(t.traveller.mobile)">
        <i class="fa-brands fa-whatsapp"></i>
      </button>
      <button (click)="email(t.traveller.email)">
        <i class="fa-regular fa-envelope"></i>
      </button>
      <button class="view-btn" (click)="viewDetails(t.id)">View</button>
    </div>
    <!-- STATUS BUTTON -->
    <button class="status-btn" (click)="updateStatus(t.id)">
      {{
        t.status === 'Pending' ? 'Accept Trip' :
        t.status === 'Accepted' ? 'Start Trip' :
        t.status === 'On Trip' ? 'Complete Trip' :
        'Completed'
      }}
    </button>
  </div>
</div>
